export default __webpack_public_path__ + "static/media/unicorn_banner.b11cbe59.png";